import { Record } from 'immutable';

export const USERINFO_REDUCER_KEY = 'userInfoStore';

export const mkUserinfo = Record({
  alwaysMfaMe: undefined,
  defaultChannel: undefined,
  email: undefined,
  entitlements: undefined,
  expiration: undefined,
  groups: undefined,
  id: 'me',
  phone: undefined,
  source: undefined,
  tokenIssuedAt: undefined,
  userCreatedAt: undefined,
  userId: undefined,
  username: undefined,
});
